/* eslint-disable max-len */
module.exports = {
  /* ============== PRESENTATION =============== */
  presentation: {
    sections: [
      {
        id: "cover",
        datatransition: "slide",
        content: `<h2>Геоконтроль-НН</h2>
            <h4>Комплекс лабораторий для строительства</h4><br>
            <p><small><a href="https://www.gc-nn.com">GC-NN.COM</a></small></p>`
      },
      {
        id: "slidecontrols",
        datatransition: "slide",
        content: `
          <p style="font-size: 1.5rem;">Перед тем как начнем</p>
          <h4>Горячие клавиши управления презентацией:</h4>
          <ul style="font-size: 1.5rem; color: Beige;">
            <li>F - Развернуть на полный экран (Esc - выход в нормальный режим)</li>
            <li>O - Показать все миниатюры слайдов</li>
            <li>Щелчок на Логотипе <img class="rz-reset-all-styles" src="/img/general/gc-logo-w-48.png"> в левом верхнем углу экрана - Возврат на основной сайт</li>
            <li>Выберите язык презентации используя кнопки в правом верхнем углу экрана RU/EN</li>
          </ul>
          `
      },
      {
        id: "intro01",
        databackground: "/img/presentation/surveying-01.jpg",
        datatransition: "slide-in fade-out",
        databackgroundtransition: "fade-in fade-out",
        content: `
          <div class="txt-stroke-blue-shadow">
            <p>Основанная в 2014 году, организация "Геоконтроль-НН" занималась в большей мере геодезией и маркшейдерией.</p>
            <p class="fragment fade-up">С 2018 года значительное развитие получило направление лаборатории неразрушающего контроля,</p>
            <p class="fragment fade-up">а с 2019 года "Геоконтроль-НН" имеет большую базу для проведения Механических испытаний и Строительную лабораторию.</p>
          </div>
        `
      },
      {
        id: "ndt01",
        databackground: "/img/presentation/ndt-01.jpg",
        datatransition: "fade-in fade-out",
        dataautoanimate: true,
        content: `
          <div class="txt-stroke-black-shadow" data-id="01" style="color:yellow;">Лаборатория неразрушающего контроля аттестована и аккредитована на большое количество методов:</div>
          <ul class="txt-stroke-black-shadow" data-id="02" style="font-size:0.6em; display:none; color:#FFFFCC; list-style-image:url(img/listmarkers/marker05.png)">
          </ul>
        `
      },
      {
        id: "ndt02",
        databackground: "/img/presentation/ndt-01.jpg",
        datatransition: "fade-in slide-out",
        dataautoanimate: true,
        content: `
          <div class="txt-stroke-black-shadow" data-id="01" style="">Лаборатория неразрушающего контроля аттестована и аккредитована на большое количество методов:</div>
          <ul class="txt-stroke-black-shadow" data-id="02" style="font-size:0.6em; color:#FFFFCC; list-style-image:url(img/listmarkers/marker05.png)">
            <li>Визуально-измерительный контроль</li>
            <li>Ультразвуковой контроль (в т.ч. УЗК-толщинометрия, УЗК-твердометрия, УЗК на сплошность)</li>
            <li>Радиографический контроль</li>
            <li>Контроль проникающими веществами (цветная дефектоскопия, мел-керосин)</li>
            <li>Контроль сварных швов вакуумированием и избыточным давлением</li>
            <li>Магнитопорошковый контроль</li>
            <li>Тепловизионный контроль (фасадов зданий, отдельных деталей, электро-приборов)</li>
            <li>Вибродиагностика</li>
            <li>Акустико-эмиссионный метод</li>
            <li>Рентгенофлуоресцентный химический анализ металлов и сплавов</li>
            <li>Электро-контроль изоляции / лакокрасочных покрытий труб на сплошность</li>
          </ul>
        `
      },
      {
        id: "ndt03",
        databackground: "/img/presentation/ndt-02.jpg",
        datatransition: "slide",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>Базовые методы любой Лаборатории неразрушающего контроля - <span style="color:Wheat; font-weight:bold;">ВИК, РК, УЗК, ПВК</span></p>
            <p class="fragment fade-up">В штате «Геоконтроль-НН» - <span style="color:Wheat; font-weight:bold;">28</span> аттестованных специалистов по рентген-контролю, из которых <span style="color:Wheat; font-weight:bold;">8 человек</span> - также специалисты по ультразвуковому контролю</p>
            <p class="fragment fade-up">Стаж работы большинства специалистов<br><span style="color:Wheat; font-weight:bold;">более 5 лет</span></p>
          </div>
        `
      },
      {
        id: "ndt04",
        databackground: "/img/presentation/ndt-03.jpg",
        datatransition: "slide",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>Лаборатория обеспечена достаточным количеством оборудования:</p>
            <ul style="font-size:0.7em; list-style-image:url(img/listmarkers/marker05.png)">
              <li class="fragment fade-up"><span style="color:Wheat; font-weight:bold; font-size:1.2em;">11</span> импульсных рентген-аппаратов</li>
              <li class="fragment fade-up">рентген-аппараты постоянного излучения - <span style="color:Wheat; font-weight:bold;">РПД-200С, МАРТ-200</span></li>
              <li class="fragment fade-up"><span style="color:Wheat; font-weight:bold; font-size:1.2em;">5</span> ультразвуковых-аппаратов, в т.ч. <span style="color:Wheat; font-weight:bold;">аппараты на фазированных решетках</span></li>
              <li class="fragment fade-up"><span style="color:Wheat; font-weight:bold; font-size:1.2em;">2</span> акустико-эмиссионных комплекса типа <span style="color:Wheat;">МАЛАХИТ A-LINE-32D</span> на 40 каналов и 8 каналов</li>
              <li class="fragment fade-up">установки для вакуумирования, оборудование для электроконтроля изоляции и лакокрасочных покрытий, портативные толщиномеры и многое другое</li>
            </ul>
          </div>
        `
      },
      {
        id: "ndt05",
        databackgroundgradient: "linear-gradient(to bottom, #283325, #808080)",
        datatransition: "fade-in slide-out",
        content: `
          <div class="txt-stroke-black-shadow">Работаем с широким спектром групп технических устройств:</div>
          <div class="r-stack txt-stroke-blue-shadow">
            <div class="fragment current-visible" style="widht:427px; height:428px; background-image:url(/img/presentation/lifting-beam-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:300px; width:428px; margin-left:30px; margin-right:30px;">Грузоподъемные механизмы</p>
            </div>
            <div class="fragment current-visible" style="widht:400px; height:326px; background-image:url(/img/presentation/process-pipelines-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:340px; width:400px; margin-left:30px; margin-right:30px;">Трубопроводы технологические</p>
            </div>
            <div class="fragment current-visible" style="widht:494px; height:278px; background-image:url(/img/presentation/vessels-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:300px; width:494px; margin-left:30px; margin-right:30px;">Сосуды и аппараты</p>
            </div>
            <div class="fragment current-visible" style="widht:591px; height:392px; background-image:url(/img/presentation/steel-structural-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:320px; width:591px; margin-left:30px; margin-right:30px;">Металлоконструкции</p>
            </div>
            <div class="fragment current-visible" style="widht:500px; height:334px; background-image:url(/img/presentation/gas-pipework-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:340px; width:500px; margin-left:30px; margin-right:30px;">Теплосети и газопроводы</p>
            </div>
            <div class="fragment current-visible" style="widht:605px; height:388px; background-image:url(/img/presentation/oil-storage-tanks-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:220px; width:605px; margin-left:30px; margin-right:30px;">Резервуары</p>
            </div>
            <div class="fragment current-visible" style="widht:595px; height:419px; background-image:url(/img/presentation/arms-skoba-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:300px; width:595px; margin-left:30px; margin-right:30px;">Стыковые соединения арматуры</p>
            </div>
            <div class="fragment current-visible" style="widht:750px; height:485px; background-image:url(/img/presentation/pe-pipes.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:10px; width:750px; margin-left:30px; margin-right:30px;">Трубопроводы из полимерных материалов</p>
            </div>
            <div class="fragment current-visible" style="widht:717px; height:258px; background-image:url(/img/presentation/train-veels-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:300px; width:717px; margin-left:30px; margin-right:30px;">И многое другое!</p>
            </div>
            
          </div>
        `
      },
      {
        id: "ndt06",
        databackground: "/img/presentation/sop.jpg",
        datatransition: "slide",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>На каждую группу устройств у нас есть <span style="color:Wheat; font-weight:bold;">Свой настроечный образец для УЗК</span>,</p>
            <p class="fragment fade-up">а также множество вспомогательного оборудования для иных методов контроля</p>
          </div>
        `
      },
      {
        id: "ndt07",
        databackground: "/img/presentation/rk-conclusion-01.jpg",
        datatransition: "slide",
        content: `
          <div class="txt-stroke-black-shadow-glow-white">
            <p class="fragment" style="font-size:0.7em; font-weight:bold; color:Aquamarine;">* Сфотографируй этот QR-код:  </span><img src="/img/presentation/qr-01.jpg" /></span></p>
            <p class="" style="color:Cornflowerblue;">На наших заключениях лаборатории есть QR-код, позволяющий проверить подлинность заключения, а в некоторых случаях, по просьбе Заказчика или Технического надзора, посмотреть <span style="color:Deeppink; font-weight:bold;">цифровую копию Рентген-снимков</span></p>
          </div>
        `
      },
      {
        id: "mex01",
        databackground: "/img/presentation/hardness-testing.jpg",
        datatransition: "fade-in slide-out",
        databackgroundtransition: "convex",
        content: `
          <h3 class="txt-stroke-black-shadow">Испытательная Лаборатория «Геоконтроль-НН»</h3>
        `
      },
      {
        id: "mex02",
        databackground: "/img/presentation/templates-after-tests.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>Лаборатория отлично подготовлена к испытаниям Контрольных Сварных Соединений (КСС),</p>
            <p class="fragment fade-up">выполняемых сварщиками допускных стыков на строительном объекте,</p>
            <p class="fragment fade-up">так и оценка КСС при аттестации "НАКС" или Сертификации процессов сварки.</p>
          </div>
        `
      },
      {
        id: "mex03",
        databackgroundvideo: "/img/presentation/cutting-templates.mp4",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow">Мы собственными силами вырежем темплеты из КСС</p>
        `
      },
      {
        id: "mex04",
        databackground: "/img/presentation/grinding-templates.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow">Снимем усиление сварного шва</p>
        `
      },
      {
        id: "mex05",
        databackgroundvideo: "/img/presentation/milling-templates.mp4",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow">Выполним фрезеровку</p>
        `
      },
      {
        id: "mex06",
        databackgroundvideo: "/img/presentation/impact-bend.mp4",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow">Проведем сами испытания</p>
          <p class="txt-stroke-black-shadow" style="font-size:0.7em; font-weight:bold; color:Aquamarine;">* возможно при повышенных или пониженных температурах</p>
        `
      },
      {
        id: "mex07",
        databackground: "/img/presentation/chemical-spectr-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>Кроме стандартных методов: Растяжение, Статический изгиб, Ударный изгиб,</p>
            <p class="fragment fade-up">Мы выполним высококачественно микрометаллографию,</p>
            <p class="fragment fade-up">исследование химического состава металлов или сварочных материалов</p>
          </div>
        `
      },
      {
        id: "mex08",
        databackground: "/img/presentation/flattering-02.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Выполним испытания на сплющивание и раздачу трубных образцов</p>
        `
      },
      {
        id: "mex09",
        databackground: "/img/presentation/coupling-reebar-connection-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Испытаем на растяжение муфтовые или сварные соединения арматуры диаметром до 50мм</p>
        `
      },
      {
        id: "mex10",
        databackground: "/img/presentation/pmi-02.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Быстро определим химический состав металлов (сварных швов), проверим соответствие марки материала проекту</p>
        `
      },
      {
        id: "mex11",
        databackground: "/img/presentation/big-kss.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Мы справимся даже с КСС большой толщины</p>
        `
      },
      {
        id: "mex12",
        databackground: "/img/presentation/norma-winsteel-asme.png",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>«Геоконтроль-НН» владеет лицензионной базой нормативных документов NormaCS</p>
            <p class="fragment fade-up">А также лицензионным WinSteel (марки стали всей планеты)</p>
            <p class="fragment fade-up">И большой базой зарубежных стандартов (ASME, ASTM, API, ISO, DIN, AWS...)</p>
          </div>
        `
      },
      {
        id: "mex13",
        databackground: "/img/presentation/en-ru-protocol.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow" style="color:Wheat; font-weight:bold;">По просьбе Заказчика предоставим Протоколы на 2-х языках: EN & RU</p>
        `
      },
      {
        id: "civillab01",
        databackground: "/img/presentation/civil-laboratory-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Огромная область аккредитации Испытательной Лаборатории - <span style="color:Wheat; font-weight:bold;">Испытания строительных материалов, асфальта, антикоррозионных покрытий, гидроизоляции, бетона, сыпучих веществ, пластмасс, грунтов...</span></p>
        `
      },
      {
        id: "civillab02",
        databackground: "/img/presentation/concrete-compression-01.jpg",
        dataautoanimate: true,
        content: `
        <div class="txt-stroke-black-shadow">
          <p data-id="txt04" style="margin-top:150px;">Бетон на прочность мы можем испытать не только в лабораторных условиях,</p>
          <p data-id="txt05" style="display:none;">Но и полевыми методами: отрыв со скалыванием, ударно-импульсный, ультразвуковой</p>
        </div>
        `
      },
      {
        id: "civillab03",
        databackground: "/img/presentation/shock-pulse-method.jpg",
        dataautoanimate: true,
        content: `
        <div class="txt-stroke-black-shadow">
          <p data-id="txt04">Бетон на прочность мы можем испытать не только в лабораторных условиях,</p>
          <p data-id="txt05">Но и полевыми методами: отрыв со скалыванием, ударно-импульсный, ультразвуковой</p>
        </div>
        `
      },
      {
        id: "civillab04",
        databackground: "/img/presentation/geomembranes-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Без проблем испытаем геомембраны, геотекстиль, полимерные георешетки, геодрены</p>
        `
      },
      {
        id: "civillab05",
        databackground: "/img/presentation/sifting-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Разберем на гранулометрический состав не только щебень и песок, но и любые другие сыпучие материалы</p>
        `
      },
      {
        id: "civillab06",
        databackground: "/img/presentation/soil-compaction-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Определим максимальную плотность и оптимальную влажность грунта, ПГС и др.</p>
        `
      },
      {
        id: "ic01",
        databackgroundvideo: "/img/presentation/hidrotest-valve-01.mp4",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">Одно из значимых направлений лаборатории - <span style="color:Wheat; font-weight:bold;">ГИДРАВЛИЧЕСКИЕ ИСПЫТАНИЯ ЗАПОРНОЙ АРМАТУРЫ</span></p>
        `
      },
      {
        id: "ic02",
        databackground: "/img/presentation/pmi-valve-01.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">А также Входной контроль арматуры, фитингов и других изделий нефтехимического строительства</p>
        `
      },
      {
        id: "ic03",
        databackground: "/img/presentation/dpi-01.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">Широкий спектр возможностей лабораторных испытаний позволяет нашей лаборатории проводить эффективно входной контроль любых изделий</p>
        `
      },
      {
        id: "ic04",
        databackground: "/img/presentation/ic-protocol-01.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">Максимально подробный протокол входного контроля</p>
        `
      },
      {
        id: "phwt01",
        databackgroundvideo: "/img/presentation/phwt-01.mp4",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow"><span style="color:Wheat; font-weight:bold;">ТЕРМООБРАБОТКА СВАРНЫХ СОЕДИНЕНИЙ</span></p>
        `
      },
      {
        id: "phwt02",
        databackground: "/img/presentation/phwt-02.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Большой выбор нагревательных ковриков позволяет термить не только стыковые сварные швы, но и врезки</p>
        `
      },
      {
        id: "phwt03",
        databackground: "/img/presentation/phwt-03.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">2 шестиканальных термопоста позволяют термить до 12-18 сварных стыков одновременно</p>
        `
      },
      {
        id: "phwt04",
        databackground: "/img/presentation/phwt-04.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">3 одноканальных термопоста добавляют мобильности и доступность стыков на высоте</p>
        `
      },
      {
        id: "phwt05",
        databackground: "/img/presentation/phwt-05.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <div class="txt-stroke-black-shadow">
            <p class="">6-канальные посты вместе со вспомогательным оборудованием мы перемещаем в утепленных прицепах, оборудованных кондиционерами и подогревателями,</p>
            <p class="txt-stroke-black-shadow fragment fade-up">что позволяет быстро выполнить мобилизацию на объект</p>
            <p class="txt-stroke-black-shadow fragment fade-up">и проводить работы по термообработке при любых температурах окружающего воздуха</p>
          </div>
        `
      },
      {
        id: "ellab01",
        databackgroundvideo: "/img/presentation/ellab-01.mp4",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">НОВОЕ НАПРАВЛЕНИЕ - <span style="color:Wheat; font-weight:bold;">ЭЛЕКТРОТЕХНИЧЕСКАЯ ЛАБОРАТОРИЯ</span></p>
        `
      },
      {
        id: "ellab02",
        databackground: "/img/presentation/ellab-02.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <div class="txt-stroke-black-shadow">
            <p class=""><span style="color:Wheat; font-weight:bold;">Возможности электро-лаборатории:</span></p>
            <ul style="font-size:0.8em; list-style-image:url(img/listmarkers/marker08.png)">
              <li class="fragment fade-up">Измерение электросопротивления изоляции кабелей</li>
              <li class="fragment fade-up">Измерение сопротивления заземления (работоспособности и эффективности заземления, наличие цепи между заземленными установками)</li>
              <li class="fragment fade-up">Проверка системы молниезащиты</li>
              <li class="fragment fade-up">Проверка полного сопротивления петли «фаза-нуль»</li>
              <li class="fragment fade-up">Проверка срабатывания расцепителей автоматических выключателей</li>
              <li class="fragment fade-up">Проверка и испытания автоматических выключателей, управляемых дифференциальным током (УЗО)</li>
              <li class="fragment fade-up">Тепловизионный контроль вводных и распределительных щитов / устройств</li>
            </ul>
          </div>
        `
      },
      {
        id: "whyus01",
        databackground: "/img/presentation/lyapaev-class.jpg",
        databackgroundtransition: "slide",
        content: `
          <div class="txt-stroke-black-shadow">
            <p style="color:Wheat; font-weight:bold;">Наши преимущества:</p>
            <ul style="font-size:0.8em; list-style-image: url(img/listmarkers/marker05w.png)">
              <li class="">Низкие цены <a href="/price/Price_GC_2023-2024_NK_MEX_STROY.pdf" download="Price_GC_2023-2024_NK_MEX_STROY.pdf">(💾 Скачать GC-прайс на 2023-2024 год)</a></li>
              <li class="fragment fade-up">Технически грамотный персонал, профессионалы в своем деле!</li>
              <li class="fragment fade-up">Мобильность и быстрый выезд на объект</li>
              <li class="fragment fade-up">Современное оборудование</li>
              <li class="fragment fade-up">Работаем согласно требований действующей нормативной документации</li>
              <li class="fragment fade-up">Протоколы с учетом ваших требований (возможно на 2-х языках: RU/EN)</li>
            </ul>
          </div>
        `
      },
      {
        id: "whyus02",
        databackground: "/img/presentation/automating-01.jpg",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-black-shadow">
            <p style="color:Aquamarine; font-weight:bold;">Кроме всего прочего:</p>
            <ul style="font-size:0.8em; list-style-image: url(img/listmarkers/marker05w.png)">
              <li class="">Только у нас высокая степень автоматизации работы (электронный документооборот и электронный журнал заключений)</li>
              <li class="fragment fade-up">По просьбе Заказчиков мы предоставляем доступ в личный кабинет на сайте, где можно отслеживать результаты испытаний в режиме реального времени</li>
            </ul>
          </div>
        `
      },
      {
        id: "whyus03",
        databackgroundvideo: "/img/presentation/online-journal.mp4",
        datatransition: "fade-in fade-out",
        content: ``
      },
      {
        id: "geography",
        iframe: "/geography",
        databackgroundcolor: "rgba(20, 20, 20, 100)",
        datatransition: "fade-in fade-out",
        content: ``
      },
      {
        id: "theend",
        content: `<h2>Спасибо за Ваше внимание!</h2><br>
            <p>Телефон для связи: 8-800-505-65-45</p>
            <p><small><a href="https://www.gc-nn.com">Вернуться на основной сайт - GC-NN.COM</a></small></p>`
      }
    ],
    centerMap: [58.010400, 56.229486], zoomMap: 5,
    ourObjects: [
      {
        centerLabel: [56.238242, 43.461571],
        iconLayout: "default#image", /* preset: "islands#greenStretchyIcon", */
        iconImageHref: "/img/presentation/labels/sibur.png",
        hintContent: "Сибур-Дзержинск, Сибур-Кстово" /* balloonContent: "" */
      },
      {
        centerLabel: [58.236834, 68.438199],
        iconLayout: "default#image", /* preset: "islands#greenStretchyIcon", */
        iconImageHref: "/img/presentation/labels/sibur.png",
        hintContent: "Сибур-Тобольск" /* balloonContent: "" */
      },
      {
        centerLabel: [56.150622, 44.206753],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/lukoil.png",
        hintContent: "ЛУКОЙЛ-Кстово"
      },
      {
        centerLabel: [57.918517, 56.143750],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/lukoil.png",
        hintContent: "ЛУКОЙЛ-Пермь"
      },
      {
        centerLabel: [55.644033, 37.802694],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/gazprom.png",
        hintContent: "МНПЗ. Газпром-Нефть"
      },
      {
        centerLabel: [54.131784, 36.484640],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/gazprom.png",
        hintContent: "Черепецкая ГРЭС"
      },
      {
        centerLabel: [51.237431, 47.514839],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/gazprom.png",
        hintContent: "Газпром. Мокроус"
      },
      {
        centerLabel: [53.543499, 49.607079],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/toaz.png",
        hintContent: "ТольяттиАзот"
      },
      {
        centerLabel: [51.926912, 47.909097],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/phosagro.png",
        hintContent: "Фосагро. Балаковский филиал АО 'АПАТИТ'"
      },
      {
        centerLabel: [59.919308, 32.351911],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/phosagro.png",
        hintContent: "Фосагро. Волховский филиал АО 'АПАТИТ'"
      },
      {
        centerLabel: [67.610946, 33.696134],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/phosagro.png",
        hintContent: "Кировский филиал АО 'АПАТИТ'"
      },
      {
        centerLabel: [59.883712, 30.178655],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/pnt.png",
        hintContent: "Петербургский Нефтяной Терминал"
      },
      {
        centerLabel: [59.108405, 37.971972],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/mostostroy.png",
        hintContent: "Мостострой. Мост через реку Шексна"
      },
      {
        centerLabel: [65.975364, 78.345158],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/mostostroy.png",
        hintContent: "Мостострой. Мост через реку Пур"
      },
      {
        centerLabel: [69.355657, 88.142020],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/nornikel.png",
        hintContent: "Норникель. Завод 'Надеждинский', завод 'Медный'"
      }
    ]
  }
};
/* eslint-enable max-len */
